<template>
  <el-select
    v-model="value"
    :multiple="multiple"
    filterable
    placeholder="请选择"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      options: [],
      value: "", // 当前被选择的分区的id或者id集合，即实际的类型既可能是一个字符串也可能是一个数组
    };
  },

  props: {
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    // 拉取分区集合
    this.loadZoneList();
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 清除选择
     */
    clear() {
      this.value = "";
    },

    /**
     * 查询分区集合
     */
    async loadZoneList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/zone/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.zones || [];

      // 排序（默认按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.options = [];
      for (let z of listInResponse) {
        this.options.push({
          value: z.id,
          label: z.name,
        });
      }
    },
  },
};
</script>